import axios from "axios";
import { toast } from "sonner";

// Talk to the server on the same address the page was opened from (tiertcg.com, www.tiertcg.com,
// the emergent.host address…), so one domain being unreachable never breaks the others.
// The build-time URL is only used when the page runs somewhere without its own /api (local dev).
function backendUrl() {
  const env = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return env;
  try {
    const host = window.location.hostname;
    if (env && new URL(env).hostname === host) return env;
    if (host === "localhost" || host === "127.0.0.1") return env || window.location.origin;
    return window.location.origin;
  } catch {
    return env;
  }
}
export const BACKEND_URL = backendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/** `w` (96 | 200 | 400) asks for a small WebP copy of an uploaded image (patch 35: lists and cards). */
export function resolveImageUrl(url, w) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}${w && url.startsWith("/api/files/") && !url.includes("?") ? `?w=${w}` : ""}`;
  return url;
}

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("tierpt_token") || localStorage.getItem("tierpt_user_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Patch 26 · muted / suspended members get one clear message wherever they try to take part.
api.interceptors.response.use(undefined, (err) => {
  // patch 38b: form errors from the server (422) come as a list of objects; pages show `detail` in toasts and
  // React can't draw an object (the black screen when a test account had a short password). Make it text.
  const raw = err?.response?.data?.detail;
  if (raw && typeof raw !== "string") {
    const list = Array.isArray(raw) ? raw : [raw];
    const text = list
      .map((x) => (typeof x === "string" ? x : x?.msg ? `${(x.loc || []).filter((k) => k !== "body").join(".")}${x.loc?.length > 1 ? ": " : ""}${x.msg}` : ""))
      .filter(Boolean)
      .join(" · ");
    err.response.data.detail = text || "Invalid data";
  }
  const d = err?.response?.data?.detail;
  if (typeof d === "string") {
    const pt = (localStorage.getItem("tierpt_lang") || "pt") === "pt";
    if (d.startsWith("muted:")) {
      const until = d.slice(6);
      const date = until === "perm" ? "" : new Date(until).toLocaleString(pt ? "pt-PT" : "en-GB", { dateStyle: "medium", timeStyle: "short" });
      toast.error(
        pt
          ? date ? `A tua conta está silenciada até ${date}. Podes continuar a navegar, mas não votar nem comentar.` : "A tua conta está silenciada. Podes continuar a navegar, mas não votar nem comentar."
          : date ? `Your account is muted until ${date}. You can still browse, but not vote or comment.` : "Your account is muted. You can still browse, but not vote or comment.",
        { id: "muted", duration: 7000 }
      );
      err.handled = true;
    } else if (d === "This account has been suspended") {
      toast.error(pt ? "Esta conta foi suspensa. Se achas que é um erro, contacta-nos." : "This account has been suspended. If you think this is a mistake, contact us.", { id: "suspended", duration: 8000 });
      err.handled = true;
    }
  }
  return Promise.reject(err);
});

export function getVoterId() {
  let id = localStorage.getItem("tierpt_voter_id");
  if (!id) {
    id = `v_${crypto.randomUUID()}`;
    localStorage.setItem("tierpt_voter_id", id);
  }
  return id;
}
